import React, { useEffect } from 'react'

import IconChevronRight from 'client/icons/ChevronRight'
import styles from './styles.module.css'
import { addError } from 'src/utils/clientErrorReporter'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { usePage } from 'src/hooks/usePage'
import { SECTIONS } from 'src/hooks/useKafkaEvent/constants'
import { useDevice } from 'src/hooks/useDevice'
import { BreakpointSizes } from 'src/types/device'
import { useIntl } from 'react-intl'

interface ShareLinkProps {
  source: {
    icon: React.ReactNode
    label: string
    name: string
    url: string
  }
  propertyId: number
}
const ShareLink = ({ source, propertyId }: ShareLinkProps) => {
  const intl = useIntl()
  const { pageId } = usePage()
  const { sendEvent } = useKafkaEvent({ page: pageId, eventName: 'click' })
  const { activeBreakpoint } = useDevice()

  const isWide = activeBreakpoint > BreakpointSizes.M
  const { name, icon, label, url } = source

  useEffect(() => {
    const currentUrl = new URL(window.location.href)
    if (currentUrl.pathname === '/hotel/[country]/[slug]') {
      addError(new Error('[Share Link] Bad URL'))
    }
  }, [window?.location?.href]) // eslint-disable-line react-hooks/exhaustive-deps

  function handleClick() {
    sendEvent(
      { section: SECTIONS.SHARE_MODAL_OPTION },
      {
        option: name,
        propertyId,
      }
    )
  }

  return (
    <a
      className={styles.link}
      data-testid="share-link"
      href={`${url}${encodeURIComponent(window.location.href)}`}
      target={isWide ? '_blank' : '_self'}
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {icon}
      <p>{intl.formatMessage({ id: label })}</p>
      <IconChevronRight />
    </a>
  )
}

export default ShareLink
